import { Component, Input, OnInit } from '@angular/core';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { Invoice } from 'src/app/shared/models/invoice.interface';

@Component({
  selector: 'app-house-bill-landing',
  templateUrl: './house-bill-landing.component.html',
  styleUrls: ['./house-bill-landing.component.scss']
})
export class HouseBillLandingComponent implements OnInit {
  @Input() invoices: Invoice[] = [];
  @Input() viewMode: string = 'individual';

  settings: any = null;
  logoUrl: string = '';

  constructor(private _globalService: GlobalStateService) {}

  ngOnInit(): void {
    this._globalService.GetSetting().subscribe((res: any) => {
      this.settings = res.contacts?.english;
      this.logoUrl = res.logo || '';
    });
  }

  formatDate(dateString: string | null | undefined): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).toUpperCase();
  }

  getTotalM3(invoice: Invoice): string {
    if (this.viewMode === 'merged' && invoice.vehicles) {
      const total = invoice.vehicles.reduce((sum: number, v: any) => sum + (parseFloat(v.m3) || 0), 0);
      return total > 0 ? total.toFixed(2) : '-';
    }
    return invoice.vehicle?.m3 || '-';
  }

  getTotalWeight(invoice: Invoice): string {
    if (this.viewMode === 'merged' && invoice.vehicles) {
      const total = invoice.vehicles.reduce((sum: number, v: any) => sum + (v.weight || v.car_weight || 0), 0);
      return total > 0 ? `${total} KGS` : '-';
    }
    const w = invoice.vehicle?.weight || invoice.vehicle?.car_weight;
    return w ? `${w} KGS` : '-';
  }
}
